import React from 'react';

// C5 Payment Voucher for cash handovers.
// Debit = account holder paid out;  Credit = account holder received.
export const PathologyPaymentSlip = ({ className, voucherNo, date, accountHolder, records = [] }) => {
  const printedAt = new Date().toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true,
  });
  const totalDebit = records.filter((r) => r.type === 'Debit').reduce((s, r) => s + (Number(r.amount) || 0), 0);
  const totalCredit = records.filter((r) => r.type === 'Credit').reduce((s, r) => s + (Number(r.amount) || 0), 0);
  const net = totalCredit - totalDebit;
  const displayDate = date ? new Date(date).toLocaleDateString('en-GB') : '';

  return (
    <div className={`${className} hidden`}>
      <style>{`
        @media print {
          @page { size: 162mm 229mm; margin: 0; }
          html, body { margin: 0 !important; padding: 0 !important; }
          body * { visibility: hidden; }
          .${className}, .${className} * { visibility: visible; }
          .${className} { display: block !important; position: absolute; left: 0; top: 0; width: 162mm; }
          .${className} * { color: #000 !important; }

          .pv-slip { display: flex; flex-direction: column; min-height: 229mm; box-sizing: border-box; padding: 8mm 9mm; font-family: Arial, sans-serif; font-size: 9pt; }
          .pv-body { flex: 1 0 auto; }

          .pv-header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 6px; margin-bottom: 8px; }
          .pv-name { font-size: 17pt; font-weight: 800; }
          .pv-addr { font-size: 8pt; margin-top: 2px; }
          .pv-title { text-align: center; font-size: 13pt; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; margin: 6px 0 10px; }

          .pv-meta { display: flex; justify-content: space-between; font-size: 9.5pt; margin-bottom: 4px; }
          .pv-meta strong { font-weight: 700; }
          .pv-holder { font-size: 9.5pt; margin-bottom: 10px; }

          .pv-slip table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
          .pv-slip th, .pv-slip td { border: 1px solid #000; padding: 4px 7px; font-size: 9pt; line-height: 1.25; }
          .pv-slip th { background: #e6e6e6 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; font-weight: 700; text-align: left; }
          .pv-slip td.num, .pv-slip th.num { text-align: right; }
          .pv-slip td.ctr, .pv-slip th.ctr { text-align: center; }

          .pv-totals { width: 60%; margin-left: auto; font-size: 9.5pt; }
          .pv-totals > div { display: flex; justify-content: space-between; padding: 2px 0; border-bottom: 1px dotted #999; }
          .pv-totals > div.net { font-weight: 800; font-size: 11pt; border-top: 2px solid #000; border-bottom: none; margin-top: 3px; padding-top: 4px; }

          .pv-bottom { flex-shrink: 0; }
          .pv-sign { display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 9pt; }
          .pv-sign > div { width: 42%; text-align: center; }
          .pv-sign .sign-space { height: 34px; }
          .pv-sign .line { border-top: 1.5px solid #000; margin: 0 8px 4px; }
          .pv-sign .role { font-weight: 700; font-size: 9pt; letter-spacing: 0.3px; }
          .pv-sign .sub { font-size: 7pt; color: #555 !important; margin-top: 1px; }

          .pv-footer { text-align: center; font-size: 7pt; margin-top: 8px; border-top: 1px solid #ccc; padding-top: 4px; }

          .pv-slip::before { content: "Mukti Hospital"; position: fixed; top: 50%; left: 50%; transform: translate(-50%,-50%) rotate(-40deg); font-size: 46pt; font-weight: 800; color: rgba(0,0,0,0.05); z-index: -1; white-space: nowrap; }
        }
      `}</style>

      <div className="pv-slip">
        <div className="pv-body">
          <div className="pv-header">
            <div className="pv-name">Mukti Hospital</div>
            <div className="pv-addr">Race Course, Sasongacha, Cumilla</div>
            <div className="pv-addr">Pathology: 01673-625038 &nbsp;·&nbsp; Emergency: 01711-796905</div>
          </div>

          <div className="pv-title">Payment Voucher</div>

          <div className="pv-meta">
            <span><strong>Voucher No:</strong> {voucherNo}</span>
            <span><strong>Date:</strong> {displayDate}</span>
          </div>
          <div className="pv-holder"><strong>Account Holder:</strong> {accountHolder}</div>

          <table>
            <thead>
              <tr>
                <th className="ctr" style={{ width: '8%' }}>SL</th>
                <th style={{ width: '32%' }}>From</th>
                <th style={{ width: '30%' }}>To</th>
                <th className="ctr" style={{ width: '15%' }}>Type</th>
                <th className="num" style={{ width: '15%' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {records.length === 0 ? (
                <tr><td colSpan={5} className="ctr">No records</td></tr>
              ) : records.map((r, i) => (
                <tr key={i}>
                  <td className="ctr">{i + 1}</td>
                  <td style={{ textTransform: 'capitalize' }}>{(r.from || '').toLowerCase()}</td>
                  <td style={{ textTransform: 'capitalize' }}>{(r.to || '').toLowerCase()}</td>
                  <td className="ctr">{r.type}</td>
                  <td className="num">{(Number(r.amount) || 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pv-totals">
            <div><span>Total Debit (Paid Out):</span><span>৳ {totalDebit.toFixed(2)}</span></div>
            <div><span>Total Credit (Received):</span><span>৳ {totalCredit.toFixed(2)}</span></div>
            <div className="net">
              <span>{net > 0 ? "Net Received:" : net < 0 ? "Net Paid Out:" : "Balanced:"}</span>
              <span>৳ {Math.abs(net).toFixed(2)}</span>
            </div>
          </div>

          </div>

        <div className="pv-bottom">
          <div className="pv-sign">
            <div>
              <div className="sign-space"></div>
              <div className="line"></div>
              <div className="role">Handed By</div>
              <div className="sub">{accountHolder}</div>
            </div>
            <div>
              <div className="sign-space"></div>
              <div className="line"></div>
              <div className="role">Received By</div>
              <div className="sub">Signature &amp; Date</div>
            </div>
          </div>
          <div className="pv-footer">
            Printed: {printedAt} &nbsp;|&nbsp; Software Powered By: Microters · microters.com
          </div>
        </div>
      </div>
    </div>
  );
};